__turbopack_context__.v({
  "active": "ToggleInput-module__epxk9W__active",
  "toggleBtn": "ToggleInput-module__epxk9W__toggleBtn",
  "toggleLabel": "ToggleInput-module__epxk9W__toggleLabel",
  "toggleThumb": "ToggleInput-module__epxk9W__toggleThumb",
  "toggleTrack": "ToggleInput-module__epxk9W__toggleTrack",
});
